export default {"src":"/_next/static/media/download-app-store.55a0ac7c.svg","height":44,"width":149};